import { fetchAllCollections } from "@/components/CollectionsPage/api";
import { setCollectionData, setLoading } from "@/components/CollectionsPage/redux/slice";

export const RefreshSavedCollections = (token: string) => {
  return async (dispatch): Promise<any> => {
    dispatch(setLoading(true));

    try {
      const collectionsData: any = await fetchAllCollections(token);

      if (collectionsData) {
        dispatch(setCollectionData(collectionsData?.savedCollection));
      } else {
        console.error(collectionsData);
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setLoading(false));
    }
  };
};
